"use client";

import React from "react";
import { useRouter } from "lib/router";

import { withStorePrefix } from "app/utils";
import type { LocaleOfStoreType } from "@beautypie/core";
import { BasketCount } from "../BasketCount";
import { basketButton, disabledBasketButton } from "./style.css";
import { hideForMobile } from "../Header/Menu/styles.css";

type Props = {
  locale: LocaleOfStoreType;
};

export const BasketLink: React.FC<Props> = ({ locale }) => {
  const router = useRouter();

  const isBasketPage = ["/basket", "/us/basket"].includes(router.pathname);

  return (
    <a
      role="menuitem"
      aria-label="Go to basket"
      className={`${basketButton} ${isBasketPage ? disabledBasketButton : ""}`}
      href={`${isBasketPage ? "" : withStorePrefix("/basket", locale)}`}
    >
      <BasketCount disabled={isBasketPage} />
      <p className={hideForMobile}>Basket</p>
    </a>
  );
};
